<template>
    <div class="common-menu bg-primary">
        <div class="container px-0 d-flex flex-row justify-content-between">
            <b-navbar type="dark" class="text-light site" toggleable="md">
                <b-navbar-toggle target="navbarNavDropdown"/>
                <b-collapse is-nav id="navbarNavDropdown">
                    <b-navbar-nav>
                        <b-nav-item
                            v-for="(item, i) in commonMenu"
                            :key="i"
                            class="pl-0 main-menu-link"
                            :link-classes="{'text-nowrap': item.nowrap, 'pl-0 text-light text-md-center': true}"
                            :to="item.to"
                            @click="resetLotPage"
                        >
                            {{ item.name }}
                        </b-nav-item>
                    </b-navbar-nav>
                </b-collapse>
            </b-navbar>
            <b-overlay :show="!$auth.watch.loaded" rounded spinner-variant="primary">
                <b-button-group v-if="$auth.check()" class="navbar flex-nowrap">
                    <b-button pressed variant="light">
                        <fa :icon="['fas', 'user']"/>
                    </b-button>
                    <b-dropdown right variant="light" @hide="onHideMenu">
                        <b-dropdown-item
                            v-for="item in personalMenu"
                            :key="item.id"
                            :to="{ name: item.name }"
                            active-class="active"
                        >{{ item.label }}
                            <b-badge pill v-if="item.badge && getCounter(item.badge) > 0"
                                     :variant="getBadgeVariant(item.badge)">
                                {{ getCounter(item.badge) }}
                            </b-badge>
                        </b-dropdown-item>
                        <b-dropdown-divider/>
                        <b-dropdown-item v-if="isAdminOrOperator"
                                         active-class="active" @click="toggleNotifications">
                            <template #default>
                                <b-overlay :show="disabledNotificationsLoading">
                                    Показывать уведомления
                                    <b-checkbox
                                        class="d-inline-block"
                                        switch
                                        :checked="!disabledNotifications"
                                    />
                                </b-overlay>
                            </template>

                        </b-dropdown-item>
                        <b-dropdown-item v-if="isAdminOrOperator"
                                         :to="{name: 'profile.change-password'}"
                                         active-class="active">
                            Сменить пароль
                        </b-dropdown-item>
                        <b-dropdown-item v-on:click="logout" id="exitApp">Выход</b-dropdown-item>

                        <template v-if="this.userLabel">
                            <b-dropdown-divider/>
                            <h6 class="dropdown-header">{{this.userLabel}}</h6>
                        </template>
                    </b-dropdown>
                </b-button-group>
                <div class="header-auth-actions" v-else>
                    <auth-login-modal id="login-modal"/>
                    <b-button-group class="d-sm-flex navbar flex-nowrap">
                        <b-button v-b-modal.login-modal variant="light">Вход</b-button>
                        <b-button :to="{ name: 'auth' }" variant="success">Регистрация</b-button>
                    </b-button-group>
                </div>
            </b-overlay>
        </div>
    </div>

</template>

<script>
import AuthLoginModal from "@features/Auth/AuthLoginModal";

export default {
        name: "AppCommonMenu",
        components: {AuthLoginModal},
        props: {
            personalMenu: {
                type: Array
            }
        },
        computed: {
            userLabel() {
                const role = this.$auth?.watch?.data?.role
                switch (role) {
                    case "operator":
                        return "Оператор";
                    case "operator-buhgalter":
                        return "Оператор-бухгалтер";
                    case "admin":
                        return "Администратор";
                    default:
                        return this.$auth.watch?.data?.profile_label;
                }
            },
            notReadMessagesCount() {
                return this.$store.state.Messages.usersNotRead
            },
            notReadOrganizersMessagesCount() {
                return this.$store.state.Messages.organizersNotRead
            },
            isAdminOrOperator() {
                const role = this.$auth.watch?.data?.role
                return ['admin', 'operator', 'operator-buhgalter'].includes(role)
            },
            disabledNotifications() {
                return this.$auth.watch?.data?.disabled_notifications
            }
        },
        data: () => ({
            hideMenu: true,
            disabledNotificationsLoading: false,
            commonMenu: [
                {
                    name: "Торги",
                    to: {
                        name: "main",
                    },
                    authRequired: false,
                    onlyWhenLoggedOut: false,
                },
                {
                    name: "Регламент",
                    to: {
                        name: "page",
                        params: {type: "reglament"},
                    },
                    authRequired: false,
                    onlyWhenLoggedOut: false,
                },
                {
                    name: "Тарифы",
                    to: {
                        name: "page",
                        params: {type: "price_plans"},
                    },
                    authRequired: false,
                    onlyWhenLoggedOut: false,
                },
                {
                    name: "О площадке",
                    to: {
                        name: "page",
                        params: {type: "about"},
                    },
                    authRequired: false,
                    onlyWhenLoggedOut: false,
                    nowrap: true
                },
                {
                    name: "Обучение",
                    to: {
                        name: "page",
                        params: {type: "user_manual"},
                    },
                    authRequired: false,
                    onlyWhenLoggedOut: false,
                },
                {
                    name: "Вопросы-ответы",
                    to: {
                        name: "faq",
                    },
                    authRequired: false,
                    onlyWhenLoggedOut: false,
                },
                {
                    name: "График работы",
                    to: {
                        name: "page",
                        params: {type: "worktime"},
                    },
                    authRequired: false,
                    onlyWhenLoggedOut: false,
                },
                {
                    name: "Контакты",
                    to: {
                        name: "feedback",
                    },
                    authRequired: false,
                    onlyWhenLoggedOut: false,
                }
            ]
        }),
        methods: {
            onHideMenu(e) {
                  if(!this.hideMenu) {
                      e.preventDefault();
                      this.hideMenu = true;
                  }
            },
            async toggleNotifications() {
                this.hideMenu = false;
                this.disabledNotificationsLoading = true;
                await axios.put('/profile/toggleDisabledNotifications', {
                    disabled: this.disabledNotifications
                })
                console.log({
                    disabled: this.disabledNotifications
                })
                await this.$auth.fetch();
                this.disabledNotificationsLoading = false
            },
            logout() {
                const id = this.$auth?.watch?.data?.id
                if (!id) {
                    return
                }

                let channel = `user-alert.${id}`
                Echo.leaveHard(channel)
                this.$auth.logout()
            },
            getCounter(name) {
                return this[name];
            },
            getBadgeVariant(name) {
                switch (name) {
                    case 'notReadMessagesCount':
                        return 'danger'
                    case 'notReadOrganizersMessagesCount':
                        return 'danger'
                    default:
                        return 'secondary'
                }
            },
            resetLotPage() {
                this.$store.commit('Lots/resetPage')
                this.$store.commit('MyLots/resetPage')
                this.$store.commit('UserLots/resetPage')
            }
        }
    }
</script>
<style scoped>
    .router-link-exact-active {
        color: #cbd3da !important;
    }
    .main-menu-link {
        margin-right: 20px;
    }

    @media (max-width: 1200px) {
        .main-menu-link {
            margin-right: 5px;
            font-size: 0.9em;
        }
    }
    @media (max-width: 991px) {
        .main-menu-link {
            margin-right: 5px;
            font-size: 0.7em;
        }
    }
    @media (max-width: 767px) {
        .main-menu-link {
            font-size: 1em;
        }
    }

</style>
